// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-11-04T21:28:05.322Z
// Property: Dakota Commons Apartment Homes (ID: 5752423586988032)
// Collections: 20 amenities, 3 floorplans (live), 10 photos, 37 POIs, 2 reviews, 5 office hours, 1 special offers (live)
// Live collections (fetched at runtime): floorplans, floorplans_full, special_offers, fees

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5726763346821120",
  "multihub_property_id": "5752423586988032",
  "property_external_id": "889467",
  "property_zillow_url": "https://www.zillow.com/apartments/williston-nd/dakota-commons-apartment-homes/5hQtqc/",
  "property_apartments_url": "https://www.apartments.com/dakota-commons-williston-nd/sp55815/",
  "property_google_business_url": "https://www.google.com/maps/place/Dakota+Commons/data=!4m2!3m1!1s0x0:0xa10985257dc0bbfe?sa=X&ved=2ahUKEwjUrOWfpLiSAxUvg4kEHVgaNBoQ_BJ6BAgSEAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": "47745296913",
  "property_crm_software": "Yardi RentCafe",
  "property_pm_software": "Yardi",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "dakota-commons-apartment-homes",
  "property_name": "Dakota Commons Apartment Homes",
  "property_website_url": "https://www.dakotacommonsapartmenthomes.com",
  "property_domain": "https://www.dakotacommonsapartmenthomes.com",
  "property_address": "123 30th St. E.",
  "property_full_address": "123 30th St E, Williston, ND 58801",
  "property_address_1": "123 30th St E",
  "property_address_2": null,
  "property_address_city": "Williston",
  "property_address_state": "ND",
  "property_address_zip_full": "58801",
  "property_address_zip": "58801",
  "property_address_country": "US",
  "property_address_county": "Williams County",
  "property_neighborhood_address": "North Dakota Area",
  "property_address_latitude": "48.17283399999999",
  "property_address_longitude": "-103.6213641",
  "property_email": "dakotacommons@weidner.com",
  "property_phone": "(701) 204-0018",
  "property_call_tracking_phone": "701-204-0018",
  "property_company_name": "Weidner Apartment Homes",
  "property_company_url": "https://www.weidner.com/",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "At Dakota Commons Apartment Homes in Williston, ND, spacious floor plans await, featuring one, two, and three-bedroom options tailored for your lifestyle. Enjoy pet-friendly amenities, convenient online services, and on-site maintenance, ensuring your comfort and ease. Find your new home today—browse available units or schedule a tour!",
  "property_long_description": "Welcome to Dakota Commons Apartment Homes, where comfort meets convenience in the heart of Williston, ND. Our thoughtfully designed community offers a range of spacious floor plans, including inviting one, two, and three-bedroom apartments, perfect for singles, families, and anyone in between. Each unit is equipped with modern features such as air conditioning ports, walk-in closets, and in-home washers, ensuring you have everything you need for a comfortable lifestyle.\n\nAt Dakota Commons, we understand that pets are part of the family. That's why we are proud to be a pet-friendly community, complete with dedicated pet waste stations to keep our surroundings clean and enjoyable. Enjoy the ease of online payments and on-site maintenance, making day-to-day living stress-free. Should you need assistance, our online service requests ensure prompt responses from our dedicated team.\n\nOur prime location in Williston means you're never far from shopping, dining, and entertainment options. Plus, spacious laundry facilities with folding tables guarantee that chore time is as effortless as possible.\n\nFind your new home today! Browse our availability or schedule a tour to visit our vibrant community and experience firsthand all the amenities Dakota Commons has to offer. Your ideal living space awaits!",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5752423586988032/019d01a1-857f-7751-a1a5-f8a69279383a.webp",
  "property_featured_image_media": {
    "alt_text": "Living room with two sofas, coffee table, rug, and a balcony view.",
    "public_id": "019d01a1-857f-7751-a1a5-f8a69279383a",
    "storage_key": "property/5752423586988032/019d01a1-857f-7751-a1a5-f8a69279383a.webp",
    "width": 1536,
    "height": 1024
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "44",
  "property_year_built": "2014",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "90.9090909090909",
  "property_admin_fee": null,
  "property_application_fee": null,
  "property_fees_deposit_info": "Deposit: $750",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "250",
  "property_pet_deposit": "250",
  "property_monthly_pet_rent": "35",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "50",
  "property_pet_restrictions": "Breed restrictions apply",
  "property_pet_policy_description": "Up to 2 pets per home are welcome.",
  "property_petpolicy_info": null,
  "property_online_leasing_url": "https://alaska-weidner.securecafe.com/onlineleasing/dakota-commons-0/floorplans.aspx",
  "property_resident_portal_url": "https://alaska-weidner.securecafenet.com/residentservices/dakota-commons-0/userlogin",
  "property_apply_now_url": "https://alaska-weidner.securecafe.com/onlineleasing/dakota-commons-0/guestlogin.aspx",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5752423586988032/019d01a3-0b14-73d4-8016-638128ea2264.webp",
  "property_primary_logo_media": {
    "alt_text": "Dakota Commons Apartment Homes logo",
    "public_id": "019d01a3-0b14-73d4-8016-638128ea2264",
    "storage_key": "property/5752423586988032/019d01a3-0b14-73d4-8016-638128ea2264.webp",
    "width": 155,
    "height": 75
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5752423586988032/019d01a3-0b3d-77fe-96fe-9a1ed2746d5b.webp",
  "property_secondary_logo_media": {
    "alt_text": "Dakota Commons Apartment Homes logo.",
    "public_id": "019d01a3-0b3d-77fe-96fe-9a1ed2746d5b",
    "storage_key": "property/5752423586988032/019d01a3-0b3d-77fe-96fe-9a1ed2746d5b.webp",
    "width": 175,
    "height": 85
  },
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5752423586988032/019d01a3-0b3d-77fe-96fe-9a1ed2746d5b.webp",
  "property_mono_white_logo_media": {
    "alt_text": "Dakota Commons Apartment Homes logo.",
    "public_id": "019d01a3-0b3d-77fe-96fe-9a1ed2746d5b",
    "storage_key": "property/5752423586988032/019d01a3-0b3d-77fe-96fe-9a1ed2746d5b.webp",
    "width": 175,
    "height": 85
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5752423586988032/01a0d97d-c43a-74e9-a281-4666a3d8878e.webp",
  "property_mono_black_logo_media": {
    "alt_text": null,
    "public_id": "01a0d97d-c43a-74e9-a281-4666a3d8878e",
    "storage_key": "property/5752423586988032/01a0d97d-c43a-74e9-a281-4666a3d8878e.webp",
    "width": 155,
    "height": 75
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d0198-4291-7593-82c0-efd4c864db24.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d0198-5322-7081-947b-e809ba802b6c.webp",
  "property_company_logo_media": {
    "alt_text": "Weidner Apartment Homes logo",
    "public_id": "019d0198-5322-7081-947b-e809ba802b6c",
    "storage_key": "company/5726763346821120/019d0198-5322-7081-947b-e809ba802b6c.webp",
    "width": 1342,
    "height": 402
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d270e-bdc5-779e-a400-a391326cc801.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "Weidner Apartment Homes logo",
    "public_id": "019d270e-bdc5-779e-a400-a391326cc801",
    "storage_key": "company/5726763346821120/019d270e-bdc5-779e-a400-a391326cc801.webp",
    "width": 640,
    "height": 192
  },
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d270e-c548-748f-97de-b042810ed358.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "Weidner Apartment Homes logo",
    "public_id": "019d270e-c548-748f-97de-b042810ed358",
    "storage_key": "company/5726763346821120/019d270e-c548-748f-97de-b042810ed358.webp",
    "width": 640,
    "height": 192
  },
  "property_primary_color": "#1A4C4C",
  "property_secondary_color": "#C5CAED",
  "property_font_color": null,
  "property_color_4": null,
  "property_color_3": "#416D92",
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 2",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "3",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "758 - 1175",
  "property_sqft_min": "758",
  "property_sqft_max": "1578",
  "property_price_range": "1390 - 1547",
  "property_price_min": "1390",
  "property_price_max": "1547",
  "property_available_units": 4,
  "property_facebook_url": "https://www.facebook.com/DakotaCommonsApartments/",
  "property_instagram_url": "https://www.instagram.com/dakotacommonsapts/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJn0ZI48ZcIVMR_rvAfSWFCaE",
  "property_youtube_url": "https://www.youtube.com/@WeidnerApartmentHomes",
  "property_yelp_url": null,
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Dakota Commons Apartment Homes",
  "property_home_romance_title": "Embrace Life and Love in Your New Apartment Home",
  "property_home_amenities_blurb": "Welcome to Dakota Commons Apartment Homes in Williston, ND, where spacious floor plans meet modern convenience. Enjoy pet-friendly living with features like walk-in closets, in-unit washers, and dedicated laundry rooms. Embrace a smoke-free lifestyle while making online payments and service requests with ease. Your perfect home awaits!",
  "property_home_floorplans_blurb": "Welcome to Dakota Commons Apartment Homes in Williston, ND, where versatile living meets comfort. Choose your ideal space from our thoughtfully designed one, two, or three-bedroom floor plans. Embrace modern amenities and vibrant community life—browse our available apartments today and find the perfect home tailored just for you!",
  "property_home_gallery_blurb": "At Dakota Commons Apartment Homes in Williston, ND, envision your ideal lifestyle with our spacious one, two, and three-bedroom floor plans. Enjoy eco-friendly amenities like online payments and pet-friendly spaces, complemented by walk-in closets and convenient laundry facilities. Picture yourself living here and elevate your everyday comfort today!",
  "property_home_neighborhood_blurb": "At Dakota Commons Apartment Homes in Williston, ND, vibrant living awaits! Choose from thoughtfully designed one, two, or three-bedroom floor plans. Immerse yourself in our lively neighborhood, where local favorites and hidden gems abound. Dive into the community and uncover the charm that surrounds our apartments today!",
  "property_home_reviews_blurb": "At Dakota Commons Apartment Homes in Williston, ND, residents rave about their experience, with one saying, “It feels like home from day one!” Join a vibrant community where comfort and convenience unite. See what our residents have to say about living at our community and embrace your new lifestyle today!",
  "property_neighborhood_blurb": "At Dakota Commons Apartment Homes in Williston, ND, vibrant living meets local charm. Nestled near Books On Broadway and Country Floral, our community offers a perfect blend of leisure and convenience. Embrace the artistic spirit and explore nearby gems waiting to be discovered just outside your front door.",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "At Dakota Commons Apartment Homes in Williston, ND, enjoy spacious one, two, and three-bedroom floor plans designed for modern living. Revel in pet-friendly comforts, online convenience, and generous amenities like walk-in closets, air conditioning ports, and a well-equipped laundry room. Come home to a community that prioritizes your ease and lifestyle!",
  "property_applynow_blurb": "At Dakota Commons Apartment Homes in Williston, ND, spacious floor plans await, whether you prefer a cozy one-bedroom or a generous three-bedroom. Enjoy pet-friendly living with modern amenities like online payments, on-site maintenance, and convenient laundry facilities. Make the leap—find your new home and lease online today!",
  "property_contactus_blurb": "At Dakota Commons Apartment Homes in Williston, ND, we offer a variety of thoughtfully designed floor plans, including one, two, and three-bedroom options. Each layout harmonizes comfort and style, perfect for every lifestyle. Curious about your new home? Our leasing team is ready to assist—reach out today!",
  "property_faqs_blurb": "At Dakota Commons Apartment Homes in Williston, ND, each thoughtfully designed space—whether a cozy one-bedroom or a spacious three-bedroom—offers a unique lifestyle. Curious about our community? Visit our FAQs page to uncover everything you need to know about calling Dakota Commons home. Your perfect fit awaits!",
  "property_floorplans_blurb": "At Dakota Commons Apartment Homes in Williston, ND, your ideal living space awaits. Choose from stylish one, two, or three-bedroom floor plans designed for comfort and convenience. Each layout enhances your lifestyle. Browse our available apartments today and uncover the perfect fit for your home sweet home!",
  "property_gallery_blurb": "At Dakota Commons Apartment Homes in Williston, ND, vibrant living meets comfort. Choose from one, two, or three-bedroom floor plans, each designed for your lifestyle. Enjoy pet-friendly amenities, convenient online payments, and spacious interiors crafted for relaxation. Picture yourself dwelling in this inviting community—your new home awaits!",
  "property_interactivemap_blurb": "At Dakota Commons Apartment Homes in Williston, ND, you'll find spacious one, two, and three-bedroom floor plans designed for comfort and convenience. Enjoy pet-friendly living with convenient amenities like online payments and on-site maintenance. Dive into our interactive community map to explore your future home and pricing options today!",
  "property_pets_blurb": "At Dakota Commons Apartment Homes in Williston, ND, lush green landscapes meet modern living. Enjoy spacious layouts, resort-style amenities, and a vibrant community—all with your furry friend by your side. With our pet-friendly policy, you and your beloved companions can truly feel at home in this charming oasis.",
  "property_referafriend_blurb": "At Dakota Commons Apartment Homes in Williston, ND, our welcoming community offers an array of thoughtfully designed floor plans, including one, two, and three-bedroom options. Share the joy of living here with your friends—great friends make great neighbors! Refer a friend to join our vibrant community today!",
  "property_residentaccess_blurb": "Welcome to Dakota Commons Apartment Homes in Williston, ND, where comfort meets versatility! Choose from our thoughtfully designed one, two, or three-bedroom floor plans tailored to your lifestyle. Enhance your living experience by accessing our resident portal for easy rent payments, maintenance scheduling, and community updates. Seamless living begins here!",
  "property_reviews_blurb": "At Dakota Commons Apartment Homes in Williston, ND, residents rave about their experience: \"The community is welcoming, and the management truly cares.\" Get a glimpse of life in our vibrant community—see what our residents have to say about living at Dakota Commons! Your new home awaits.",
  "property_created_at": "1747737429597",
  "property_scheduletour_blurb": "At Dakota Commons Apartment Homes in Williston, ND, choose from thoughtfully designed one, two, or three-bedroom floor plans tailored to your lifestyle. Experience a vibrant community where comfort meets convenience. Curious about life here? See what our residents have to say and schedule a tour today!",
  "property_thankyou_blurb": "Thank you for reaching out to Dakota Commons Apartment Homes in Williston, ND! Our diverse floor plans, from cozy one-bedroom to spacious three-bedroom options, cater to every lifestyle. We're excited to assist you in finding your perfect space—expect a prompt response from our team to guide you on your journey home.",
  "property_virtualtours_blurb": "Welcome to Dakota Commons Apartment Homes in Williston, ND, where vibrant living meets modern comfort. Choose from our spacious one, two, and three-bedroom floor plans, perfectly designed for your lifestyle. Experience your future home firsthand—take a virtual tour today and envision your life surrounded by exceptional amenities!",
  "property_copyright": "2025 All Rights Reserved. Dakota Commons Apartment Homes",
  "property_seo_title_home": "Apartment Homes with Garage - Dakota Commons - Williston, ND",
  "property_seo_description_home": "Discover apartment living with an included garage and pet-friendly spaces at Dakota Commons in Williston, ND.",
  "property_seo_title_floorplans": "Floor Plans - Dakota Commons Apartments - Williston, ND",
  "property_seo_description_floorplans": "Explore spacious 1-, 2-, and 3-bedroom floor plans at Dakota Commons in Williston, ND, each with extra-large closets and private garages.",
  "property_seo_title_amenities": "Premium Amenities - Dakota Commons Apartments - Williston, ND",
  "property_seo_description_amenities": "Enjoy in-home laundry, walk-in closets, and garages at Dakota Commons in Williston, ND. Explore all amenities here.",
  "property_seo_title_gallery": "Photo Gallery - Dakota Commons Apartments - Williston, ND",
  "property_seo_description_gallery": "View Dakota Commons' photo gallery for a peek at apartments, amenities, and the inviting community in Williston, ND.",
  "property_seo_title_virtualtours": "Dakota Commons Virtual Tour - Williston, ND Apartments",
  "property_seo_description_virtualtours": "Take a virtual tour of Dakota Commons Apartments in Williston, ND. Take a self-paced online tour and picture your new home.",
  "property_seo_title_interactivemap": "Interactive Map | Dakota Commons Apartment Homes Apartments",
  "property_seo_description_interactivemap": "Uncover your ideal living space at Dakota Commons Apartment Homes in Williston, ND. Choose from spacious one, two, or three-bedroom floor plans designed for comfort and convenience. ",
  "property_seo_title_neighborhood": "Dakota Commons Neighborhood - Williston, ND Apartments",
  "property_seo_description_neighborhood": "Live minutes from restaurants, shops, and parks at Dakota Commons near Highway 2 in Williston, ND.",
  "property_seo_title_contact": "Contact Dakota Commons Apartments - Williston, ND",
  "property_seo_description_contact": "Contact the Dakota Commons Apartments leasing team in Williston, ND, for availability, tours, and resident services.",
  "property_seo_title_faqs": "FAQs | Apartments in Williston ND",
  "property_seo_description_faqs": "Unlock the secrets of Dakota Commons Apartment Homes in Williston, ND. Our Frequently Asked Questions page provides insights on our pet-friendly community with spacious one, two, and three-bedroom floor plans. ",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Williston ND",
  "property_seo_description_reviews": "Don't take our word for it—see what our residents have to say about their living experience in our vibrant community. Join us today and elevate your lifestyle!",
  "property_seo_title_applynow": "Apply Now | Apartments in Williston ND",
  "property_seo_description_applynow": "Ready to elevate your lifestyle? Lease online today and secure your ideal apartment!",
  "property_seo_title_residentaccess": "Resident Access | Dakota Commons Apartment Homes",
  "property_seo_description_residentaccess": "Streamline your living experience with easy access to our resident portal—pay rent, schedule maintenance, and connect with your community effortlessly. ",
  "property_seo_title_referafriend": "Refer a Friend | Dakota Commons Apartment Homes",
  "property_seo_description_referafriend": "Refer a friend and build a vibrant community among great neighbors. Together, enjoy our modern amenities and charming lifestyle!",
  "property_seo_title_scheduletour": "Schedule a Tour - Dakota Commons Apartments - Williston, ND",
  "property_seo_description_scheduletour": "Book a personal or virtual tour of Dakota Commons Apartments in Williston, ND. Choose from multiple viewing options to suit your lifestyle.",
  "property_seo_title_privacy": "Privacy Policy | Dakota Commons Apartment Homes",
  "property_seo_description_privacy": "Check out photos, floor plans, amenities, rental rates & availability at Weidner Apartment Homes and submit your lease application today!",
  "property_seo_title_accessibility": "Website Accessibility | Dakota Commons Apartment Homes",
  "property_seo_description_accessibility": "\"At Dakota Commons ApartmOur comprehensive Accessibility Statement outlines our commitment to inclusivity, ensuring everyone feels at home in our community. ",
  "property_seo_title_sitemap": "Sitemap | Dakota Commons Apartment Homes",
  "property_seo_description_sitemap": "Our sitemap guides you through the array of amenities, floor plans, and community features designed for your ideal living experience. ",
  "property_seo_title_thankyou": "Thank You | Dakota Commons Apartment Homes",
  "property_seo_description_thankyou": "Thank you for reaching out to Dakota Commons Apartment Homes in Williston, ND! Your inquiry is important to us, and our dedicated team will connect with you soon to help you find your perfect home in our vibrant community. ",
  "property_seo_title_pets": "Pet Policy | Apartments in Williston, ND",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1793654764163",
  "amenities": [
    {
      "id": "ec_b45a933e4582b3d624b83bc9",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5752423586988032",
      "source": "yardi",
      "external_id": "86288382",
      "title": "Garage Included",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5752423586988032/019d99d3-2f03-7170-934b-f05be3994d3b.webp",
      "amenity_image_media": {
        "alt_text": "Exterior view of apartment building with garages and balconies.",
        "public_id": "019d99d3-2f03-7170-934b-f05be3994d3b",
        "storage_key": "property/5752423586988032/019d99d3-2f03-7170-934b-f05be3994d3b.webp",
        "width": 1152,
        "height": 768
      },
      "amenity_image_alt_text": "Dakota commons Garage View",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_87074f22404fa14862a4236f",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5752423586988032",
      "source": "yardi",
      "external_id": "86288381",
      "title": "24 Hour Emergency Maintenance",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_7572019fe2a379d1485be0f4",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5752423586988032",
      "source": "yardi",
      "external_id": "86288385",
      "title": "On-site Laundry Facilities",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c9ea10fe72ea5547b99dd4db",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5752423586988032",
      "source": "yardi",
      "external_id": "86288388",
      "title": "Street Parking",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5752423586988032/019d99d3-2f05-71da-b7f7-e5a7122804ac.webp",
      "amenity_image_media": {
        "alt_text": "Exterior view of apartment building with attached garages and balconies.",
        "public_id": "019d99d3-2f05-71da-b7f7-e5a7122804ac",
        "storage_key": "property/5752423586988032/019d99d3-2f05-71da-b7f7-e5a7122804ac.webp",
        "width": 1152,
        "height": 768
      },
      "amenity_image_alt_text": "Dakota commons Parking View",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e28fd859c643fc2fc8de2ebc",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5752423586988032",
      "source": "yardi",
      "external_id": "86288389",
      "title": "Dishwasher",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5752423586988032/019d99d3-2f15-762e-b3e1-73ddb49c3df0.webp",
      "amenity_image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances and dark wood cabinets.",
        "public_id": "019d99d3-2f15-762e-b3e1-73ddb49c3df0",
        "storage_key": "property/5752423586988032/019d99d3-2f15-762e-b3e1-73ddb49c3df0.webp",
        "width": 1152,
        "height": 768
      },
      "amenity_image_alt_text": "Dakota commons Kitchen View",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6530936e3dd13c5e41e2c3ce",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5752423586988032",
      "source": "yardi",
      "external_id": "86288390",
      "title": "Extra large Closets",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1e5b0d171a4b413c9c9b50c7",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5752423586988032",
      "source": "yardi",
      "external_id": "86288391",
      "title": "Garbage Disposal",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3e8f31974c31a65b83a69289",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5752423586988032",
      "source": "yardi",
      "external_id": "86288392",
      "title": "Microwave",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4df55c3aee5752b056c77891",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5752423586988032",
      "source": "yardi",
      "external_id": "86288394",
      "title": "Dryer",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_12cf95e19bfa7dcaaf8c169e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5752423586988032",
      "source": "yardi",
      "external_id": "86288396",
      "title": "Ample Storage",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8d7db186660859a37913d198",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5752423586988032",
      "source": "yardi",
      "external_id": "86288380",
      "title": "Pet Friendly",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5752423586988032/019d01a2-118b-76a0-9ab6-65b24cc8e390.webp",
      "amenity_image_media": {
        "alt_text": "Dog waste station and sign with a green lawn and apartment building.",
        "public_id": "019d01a2-118b-76a0-9ab6-65b24cc8e390",
        "storage_key": "property/5752423586988032/019d01a2-118b-76a0-9ab6-65b24cc8e390.webp",
        "width": 1152,
        "height": 768
      },
      "amenity_image_alt_text": "Dakota commons dog park",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5471f6861f916ecaa310e5c0",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5752423586988032",
      "source": "yardi",
      "external_id": "86288378",
      "title": "Online Payments Available",
      "amount": "false",
      "description": "Free e-check option\r\nAccepts credit card payments\r\nAccepts cash payments via MoneyGram",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c61b51c8021fd7717727a56f",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5752423586988032",
      "source": "yardi",
      "external_id": "86288393",
      "title": "Walk-in Closet",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5752423586988032/019d01a2-0f7f-746b-a4d1-9a2f640d21c5.webp",
      "amenity_image_media": {
        "alt_text": "Walk-in closet next to a bathroom with a yellow shower curtain.",
        "public_id": "019d01a2-0f7f-746b-a4d1-9a2f640d21c5",
        "storage_key": "property/5752423586988032/019d01a2-0f7f-746b-a4d1-9a2f640d21c5.webp",
        "width": 1024,
        "height": 683
      },
      "amenity_image_alt_text": "dakota commons walk in closet",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_69399a41de5c7c0b6a054002",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5752423586988032",
      "source": "yardi",
      "external_id": "86288384",
      "title": "Online Service Requests",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_afeac070eaffdf0477ec3ead",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5752423586988032",
      "source": "yardi",
      "external_id": "86288395",
      "title": "Air Conditioning Ports",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3194e135e24b563d6eef3c72",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5752423586988032",
      "source": "yardi",
      "external_id": "86288386",
      "title": "Spacious Floorplans",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_77cfea43211b6fa0fbffc94f",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5752423586988032",
      "source": "yardi",
      "external_id": "86288397",
      "title": "Washer",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_aa1025ea653f39555a6ff790",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5752423586988032",
      "source": "yardi",
      "external_id": "86288387",
      "title": "Pet Waste Stations",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_650e32a167b402a113cd4f62",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5752423586988032",
      "source": "yardi",
      "external_id": "86288398",
      "title": "Laundry Room w/ Folding Table",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5752423586988032/019d01a2-117a-74e8-9334-2446e5aad77e.webp",
      "amenity_image_media": {
        "alt_text": "Stackable washer and dryer in apartment laundry closet with shelf and hamper.",
        "public_id": "019d01a2-117a-74e8-9334-2446e5aad77e",
        "storage_key": "property/5752423586988032/019d01a2-117a-74e8-9334-2446e5aad77e.webp",
        "width": 1024,
        "height": 683
      },
      "amenity_image_alt_text": "dakota commons in unit laundry",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_78c4ffbc6265144f1c7683b1",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5752423586988032",
      "source": "yardi",
      "external_id": "124800032",
      "title": "Smoke Free",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "ec_14b1ecddc97e3140fad3acb7",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5752423586988032",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5752423586988032/019d01a1-857f-7751-a1a5-f8a69279383a.webp",
      "image_media": {
        "alt_text": "Living room with two sofas, coffee table, rug, and a balcony view.",
        "public_id": "019d01a1-857f-7751-a1a5-f8a69279383a",
        "storage_key": "property/5752423586988032/019d01a1-857f-7751-a1a5-f8a69279383a.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Apartment",
      "description": "Spacious living area with comfortable seating, perfect for relaxing or entertaining guests. Enjoy the natural light and scenic views from the balcony.",
      "link": "false",
      "alt_text": "A bright living room here at Dakota Commons featuring two light neutral sofas arranged across a wooden coffee table, a soft area rug over carpeted flooring, neutral wall art, and a floor lamp, with sliding glass doors leading to a private balcony that brings in natural light and offers an open, comfortable layout.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/ND_Dakota_Commons_Favorites%20(1).jpg"
    },
    {
      "id": "ec_987ef1389ebf0ddefa00ea63",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5752423586988032",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5752423586988032/01a1a367-1aa4-729d-b649-03d349e25518.webp",
      "image_media": {
        "alt_text": "Dakota Commons Apartment Homes logo and promotional text.",
        "public_id": "01a1a367-1aa4-729d-b649-03d349e25518",
        "storage_key": "property/5752423586988032/01a1a367-1aa4-729d-b649-03d349e25518.webp",
        "width": 2000,
        "height": 1294
      },
      "title": "Logo",
      "description": "Dakota Commons Apartment Homes logo and promotional text offering savings of up to $500 on select homes. Offer details included.",
      "link": "false",
      "alt_text": "A promotional image for Dakota Commons Apartment Homes advertising a savings of up to $500 on select homes.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/55448%20-%20Dakota%20Commons%20-%20ND.png"
    },
    {
      "id": "ec_6851e0152c9280e949d30aec",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5752423586988032",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5752423586988032/019d01a1-8724-7663-8250-d8fb7044fe32.webp",
      "image_media": {
        "alt_text": "Modern kitchen and dining area with stainless steel appliances, ample cabinet space, and an island.",
        "public_id": "019d01a1-8724-7663-8250-d8fb7044fe32",
        "storage_key": "property/5752423586988032/019d01a1-8724-7663-8250-d8fb7044fe32.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Apartment",
      "description": "Step into this beautifully appointed kitchen and dining area, featuring sleek stainless steel appliances, rich wood cabinetry, and a spacious island perfect for meal prep or casual dining.",
      "link": "false",
      "alt_text": "A modern, open kitchen here at Dakota Commons featuring rich wood cabinetry, stainless steel appliances, a spacious center island with an extended breakfast bar, warm wood-style flooring, and pendant lighting that creates a bright, functional space ideal for cooking and entertaining.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/ND_Dakota_Commons_Favorites%20(2).jpg"
    },
    {
      "id": "ec_c1f2abcb27c9ea81fab91980",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5752423586988032",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5752423586988032/019d01a1-871f-73ae-a341-eb179cf0de5d.webp",
      "image_media": {
        "alt_text": "Cozy bedroom with a queen-sized bed, nightstands, and a comfortable accent chair.",
        "public_id": "019d01a1-871f-73ae-a341-eb179cf0de5d",
        "storage_key": "property/5752423586988032/019d01a1-871f-73ae-a341-eb179cf0de5d.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Apartment",
      "description": "Step into comfort in this beautifully appointed bedroom, featuring a plush queen-sized bed, elegant nightstands, and a stylish accent chair perfect for relaxation.",
      "link": "false",
      "alt_text": "A bright, spacious bedroom here at Dakota Commons featuring neutral walls, soft carpeting, a cozy bed with light bedding, matching nightstands with lamps, a comfortable accent chair, and a large window that brings in natural light and creates a calm, inviting atmosphere.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/ND_Dakota_Commons_Favorites%20(3).jpg"
    },
    {
      "id": "ec_3c8c9ced9e79fbb2b9ef870e",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5752423586988032",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5752423586988032/019d01a1-af91-752d-834d-272b96df59c1.webp",
      "image_media": {
        "alt_text": "Bathroom with dark wood cabinets, beige countertop, white sink, and a yellow shower curtain.",
        "public_id": "019d01a1-af91-752d-834d-272b96df59c1",
        "storage_key": "property/5752423586988032/019d01a1-af91-752d-834d-272b96df59c1.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "This apartment bathroom features ample storage with dark wood cabinets, a spacious vanity, and a bright, welcoming atmosphere with a yellow shower curtain and decorative sunflowers.",
      "link": "false",
      "alt_text": "A clean, well-lit bathroom here at Dakota Commons featuring a wood-toned vanity with a single sink, a large wall mirror with overhead lighting, a white toilet, upper storage cabinets, and a tub-and-shower combination with a warm yellow shower curtain, creating a functional and inviting space.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/ND_Dakota_Commons_Favorites%20(4).jpg"
    },
    {
      "id": "ec_bfe16a6c3798ad221a45b51b",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5752423586988032",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5752423586988032/019d01a1-ee3a-740b-b041-c9b37b236038.webp",
      "image_media": {
        "alt_text": "Interior of a spacious apartment living room with beige walls, carpet, and a sliding glass door leading to a balcony.",
        "public_id": "019d01a1-ee3a-740b-b041-c9b37b236038",
        "storage_key": "property/5752423586988032/019d01a1-ee3a-740b-b041-c9b37b236038.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Enjoy the ample living space in this apartment, perfect for relaxing or entertaining. Large windows provide natural light, and a balcony offers outdoor access.",
      "link": "false",
      "alt_text": "A spacious, unfurnished living room here at Dakota Commons featuring soft neutral walls, plush carpet flooring, and a sliding glass door with an adjacent exterior door that opens to a private balcony, allowing natural light to fill the open layout and highlight the room’s generous size.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/ND_Dakota_Commons_Favorites%20(5).jpg"
    },
    {
      "id": "ec_0f951ba0fd442055006a7268",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5752423586988032",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5752423586988032/019d01a1-b611-7780-8985-fbc049aad856.webp",
      "image_media": {
        "alt_text": "Empty bedroom with beige walls and carpet",
        "public_id": "019d01a1-b611-7780-8985-fbc049aad856",
        "storage_key": "property/5752423586988032/019d01a1-b611-7780-8985-fbc049aad856.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "A spacious and clean bedroom awaiting your personal touch. Features neutral paint and carpeting.",
      "link": "false",
      "alt_text": "A bright, unfurnished bedroom here at Dakota Commons featuring soft neutral walls, plush carpet flooring, and a single window that brings in natural light, with a simple rectangular layout that offers flexibility for furniture placement and a clean, open feel.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/ND_Dakota_Commons_Favorites%20(6).jpg"
    },
    {
      "id": "ec_b4daa9f670258b5f01673ba0",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5752423586988032",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5752423586988032/019d01a1-b967-74fe-816f-0d6dae59d626.webp",
      "image_media": {
        "alt_text": "Dog waste station with instructions to clean up after pets.",
        "public_id": "019d01a1-b967-74fe-816f-0d6dae59d626",
        "storage_key": "property/5752423586988032/019d01a1-b967-74fe-816f-0d6dae59d626.webp",
        "width": 3072,
        "height": 1846
      },
      "title": "Community",
      "description": "Convenient dog waste station located on the property grounds, encouraging responsible pet ownership and cleanliness.",
      "link": "false",
      "alt_text": "A landscaped outdoor area here at Dakota Commons featuring a neatly mowed grassy path alongside the apartment building, a designated pet waste station with disposal bags, and open green space extending toward the background under a clear blue sky.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/ND_Dakota_Commons_Favorites%20(7).jpg"
    },
    {
      "id": "ec_75cfa8971b69a556fdf3a3db",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5752423586988032",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5752423586988032/019d01a1-ca12-718d-9225-cd6e7a08b765.webp",
      "image_media": {
        "alt_text": "Exterior of a multifamily apartment building with garages on the ground floor and balconies on the upper floors.",
        "public_id": "019d01a1-ca12-718d-9225-cd6e7a08b765",
        "storage_key": "property/5752423586988032/019d01a1-ca12-718d-9225-cd6e7a08b765.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "This exterior shot showcases the modern design of the apartment building, featuring private balconies and convenient ground-level garages.",
      "link": "false",
      "alt_text": "A modern apartment building exterior here at Dakota Commons featuring a three-story structure with private balconies, ground-level garages, mixed neutral siding with brick accents, and a well-maintained lawn in the foreground beneath a bright blue sky.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/ND_Dakota_Commons_Favorites%20(8).jpg"
    },
    {
      "id": "ec_d3b922d36b05c6171aa4a99d",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5752423586988032",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5752423586988032/019d01a1-d188-7177-bf57-a87c9b596144.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings with beige and brown siding, manicured lawns, and streetlights.",
        "public_id": "019d01a1-d188-7177-bf57-a87c9b596144",
        "storage_key": "property/5752423586988032/019d01a1-d188-7177-bf57-a87c9b596144.webp",
        "width": 3072,
        "height": 1843
      },
      "title": "Community",
      "description": "Modern apartment buildings featuring attractive beige and brown siding, surrounded by well-maintained landscaping and green spaces.",
      "link": "false",
      "alt_text": "A contemporary apartment building exterior here at Dakota Commons showcasing a multi-story structure with neutral two-tone siding, brick accents along the base, landscaped greenery, sidewalks, and a quiet residential street under a clear blue sky.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/ND_Dakota_Commons_Favorites%20(9).JPG"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "ec_ae8e4ec2f49eaddbbcf7e686",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5752423586988032",
      "source": "google_places",
      "poi_name": "Williston | Brewing Company",
      "poi_type": "Restaurants",
      "poi_address": "1623 2nd Ave W, Williston, ND 58801, USA",
      "poi_short_description": "Lively, late-night gastropub serving classic bar fare, plus 40 tap beers & an ample wine list.",
      "poi_long_description": "People say this gastropub offers good food, a massive beer selection, and expertly crafted drinks. They also highlight the friendly and attentive service, and the vibrant and inviting atmosphere.\n\nOther reviews mention the food can be overpriced.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5752423586988032/019d01a2-9c42-7018-92ab-e8327ef7c4f2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a2-9c42-7018-92ab-e8327ef7c4f2",
        "storage_key": "property/5752423586988032/019d01a2-9c42-7018-92ab-e8327ef7c4f2.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.willistonbrewing.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7638704886454672961&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "williston--brewing-company",
      "poi_latitude": "48.16072699999999",
      "poi_longitude": "-103.6261362",
      "poi_miles_from_property": "1.1 mi",
      "poi_walking_minutes": "24 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 701-609-5439",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5752423586988032/019d01a2-ca75-746f-960a-b49f60538e6e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a2-ca75-746f-960a-b49f60538e6e",
        "storage_key": "property/5752423586988032/019d01a2-ca75-746f-960a-b49f60538e6e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ30YNab1cIVMRQd4rZZ8hAmo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gastropub"
    },
    {
      "id": "ec_3c58309eeedf3f2db9d6dfd0",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5752423586988032",
      "source": "google_places",
      "poi_name": "Culver’s",
      "poi_type": "Restaurants",
      "poi_address": "401 Reiger Dr, Williston, ND 58801, USA",
      "poi_short_description": "Fast-food chain specializing in frozen custard & signature burgers made with Midwest beef & dairy.",
      "poi_long_description": "People say this American restaurant serves delicious burgers, chicken tenders, and ice cream. They also highlight the friendly service and fresh food.\n\nOther reviews mention the food can be expensive.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5752423586988032/019d01a2-9c2a-75ac-a6ff-c1cb398da268.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a2-9c2a-75ac-a6ff-c1cb398da268",
        "storage_key": "property/5752423586988032/019d01a2-9c2a-75ac-a6ff-c1cb398da268.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "http://www.culvers.com/restaurants/williston-nd/?utm_source=Google&utm_medium=Maps&utm_campaign=Google+Places",
      "poi_directions_map_url": "https://maps.google.com/?cid=10401132715212886260&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "culvers",
      "poi_latitude": "48.1472436",
      "poi_longitude": "-103.6562221",
      "poi_miles_from_property": "3.0 mi",
      "poi_walking_minutes": "1 hour 7 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 701-713-4411",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5752423586988032/019d01a2-ca0f-706b-9e1e-f2f08912425d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a2-ca0f-706b-9e1e-f2f08912425d",
        "storage_key": "property/5752423586988032/019d01a2-ca0f-706b-9e1e-f2f08912425d.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJw21QL39cIVMR9FD1zxg_WJA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "ec_fb9bcbb8f416c8484cfd990c",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5752423586988032",
      "source": "google_places",
      "poi_name": "Grand Buffet",
      "poi_type": "Restaurants",
      "poi_address": "1505 15th Ave W, Williston, ND 58801, USA",
      "poi_short_description": "All-you-can-eat buffet in the Clarion Hotel serving a large variety of Chinese food, plus sushi, hibachi, and ice cream.",
      "poi_long_description": "People say this buffet restaurant offers a wide variety of food. They also highlight the attentive and friendly service, and the good value.\n\nOther reviews mention the food can be tasteless.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5752423586988032/019d01a2-9cf4-725b-b0cf-5426823a7232.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a2-9cf4-725b-b0cf-5426823a7232",
        "storage_key": "property/5752423586988032/019d01a2-9cf4-725b-b0cf-5426823a7232.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.willistongrandbuffet.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14976234025514159685&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "grand-buffet",
      "poi_latitude": "48.1586487",
      "poi_longitude": "-103.6446716",
      "poi_miles_from_property": "1.9 mi",
      "poi_walking_minutes": "44 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 701-774-0088",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5752423586988032/019d01a2-ca0f-706b-9e1e-f2f08912425d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a2-ca0f-706b-9e1e-f2f08912425d",
        "storage_key": "property/5752423586988032/019d01a2-ca0f-706b-9e1e-f2f08912425d.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJCwT3EY9cIVMRRc7jq39F1s8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "buffet_restaurant"
    },
    {
      "id": "ec_d38c7824a47d8e194e773d87",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5752423586988032",
      "source": "google_places",
      "poi_name": "Doc Holliday's Roadhouse",
      "poi_type": "Restaurants",
      "poi_address": "3901 2nd Ave W, Williston, ND 58801, USA",
      "poi_short_description": "Steakhouse featuring a menu of burgers and tacos, plus beer, wine and margarita cocktails.",
      "poi_long_description": "People say this restaurant serves delicious steaks, burgers, and chicken dishes. They also highlight the generous portions, fun atmosphere with unique decor, and friendly service.\n\nOther reviews mention the food can be inconsistent.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5752423586988032/019d01a2-9c2e-76be-a4d9-7b0181934c38.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a2-9c2e-76be-a4d9-7b0181934c38",
        "storage_key": "property/5752423586988032/019d01a2-9c2e-76be-a4d9-7b0181934c38.webp",
        "width": 1280,
        "height": 622
      },
      "poi_business_url": "https://www.dochollidaysroadhouse.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=784132833460863544&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "doc-hollidays-roadhouse",
      "poi_latitude": "48.1812052",
      "poi_longitude": "-103.6269739",
      "poi_miles_from_property": "0.9 mi",
      "poi_walking_minutes": "21 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 701-609-5331",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5752423586988032/019d01a2-ca0f-706b-9e1e-f2f08912425d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a2-ca0f-706b-9e1e-f2f08912425d",
        "storage_key": "property/5752423586988032/019d01a2-ca0f-706b-9e1e-f2f08912425d.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJu4EtDNpcIVMROMInU6jM4Qo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "ec_02baf261601f9bc196fbc301",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5752423586988032",
      "source": "google_places",
      "poi_name": "River’s Edge Bar & Grill",
      "poi_type": "Restaurants",
      "poi_address": "1002 2nd St W, Williston, ND 58801, USA",
      "poi_short_description": "Burgers, prime rib, and other pub fare served in a relaxed setting with live entertainment.",
      "poi_long_description": "People say this bar and grill serves juicy burgers, ribeye sandwiches, wings, and pizza. They highlight the fair prices and fun, local atmosphere. They also like the friendly and welcoming staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5752423586988032/019d01a2-a487-76e8-b530-eafdb615e5ea.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a2-a487-76e8-b530-eafdb615e5ea",
        "storage_key": "property/5752423586988032/019d01a2-a487-76e8-b530-eafdb615e5ea.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://riversedgewilliston.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14251188445026170789&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "rivers-edge-bar--grill",
      "poi_latitude": "48.1454884",
      "poi_longitude": "-103.6382601",
      "poi_miles_from_property": "2.7 mi",
      "poi_walking_minutes": "59 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 701-774-2062",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5752423586988032/019d01a2-ca75-746f-960a-b49f60538e6e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a2-ca75-746f-960a-b49f60538e6e",
        "storage_key": "property/5752423586988032/019d01a2-ca75-746f-960a-b49f60538e6e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJOSxZvxxbIVMRpbfvfGJkxsU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bar_and_grill"
    },
    {
      "id": "ec_81932611de41315a61e57b97",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5752423586988032",
      "source": "google_places",
      "poi_name": "Menards",
      "poi_type": "Shopping & Retail",
      "poi_address": "405 32nd Ave W, Williston, ND 58801, USA",
      "poi_short_description": "Home improvement chain with assorted building materials, tools, gardening supplies & appliances.",
      "poi_long_description": "Home improvement chain with assorted building materials, tools, gardening supplies & appliances.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5752423586988032/019d01a2-a43b-77ec-a146-1506c6b8c43c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a2-a43b-77ec-a146-1506c6b8c43c",
        "storage_key": "property/5752423586988032/019d01a2-a43b-77ec-a146-1506c6b8c43c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.menards.com/store-details/store.html?store=3330&utm_source=localcard&utm_medium=organic",
      "poi_directions_map_url": "https://maps.google.com/?cid=6557511451575846376&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "menards",
      "poi_latitude": "48.1489505",
      "poi_longitude": "-103.6722161",
      "poi_miles_from_property": "3.6 mi",
      "poi_walking_minutes": "1 hour 21 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 701-774-7636",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5752423586988032/019d01a2-ca0e-7356-8a64-5777b90f80ed.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a2-ca0e-7356-8a64-5777b90f80ed",
        "storage_key": "property/5752423586988032/019d01a2-ca0e-7356-8a64-5777b90f80ed.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ0dsLa3ZcIVMR6AW8Cez1AFs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_improvement_store"
    },
    {
      "id": "ec_078689e4aa0375f106235e52",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5752423586988032",
      "source": "google_places",
      "poi_name": "Albertsons",
      "poi_type": "Shopping & Retail",
      "poi_address": "20 26th St E, Williston, ND 58801, USA",
      "poi_short_description": "Supermarket stocking produce, meat and chicken plus other groceries.",
      "poi_long_description": "People say this grocery store is clean and well-stocked, even during busy periods like holidays. They also highlight the friendly and helpful staff who provide exceptional service.\n\nSome reviews mention the prices can be expensive.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5752423586988032/019d01a2-a41f-758e-b4d5-6aea82f0a546.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a2-a41f-758e-b4d5-6aea82f0a546",
        "storage_key": "property/5752423586988032/019d01a2-a41f-758e-b4d5-6aea82f0a546.webp",
        "width": 1280,
        "height": 719
      },
      "poi_business_url": "https://local.albertsons.com/nd/williston/20-26th-st-e.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=12500285439156409754&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "albertsons",
      "poi_latitude": "48.1676414",
      "poi_longitude": "-103.6225053",
      "poi_miles_from_property": "0.4 mi",
      "poi_walking_minutes": "10 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 701-572-1097",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5752423586988032/019d01a2-ca0e-7356-8a64-5b199c621a76.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a2-ca0e-7356-8a64-5b199c621a76",
        "storage_key": "property/5752423586988032/019d01a2-ca0e-7356-8a64-5b199c621a76.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJTRfZlbhcIVMRmtXnp2Dvea0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "ec_ebe119b511797c99dbc38df3",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5752423586988032",
      "source": "google_places",
      "poi_name": "Cash Wise Foods Grocery Store",
      "poi_type": "Shopping & Retail",
      "poi_address": "300 11th St W, Williston, ND 58801, USA",
      "poi_short_description": "Relaxed grocery store featuring fresh produce and seafood, plus a deli, a bakery and friendly service.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5752423586988032/019d01a2-a4ca-713a-b8d7-74d0f3f3f244.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a2-a4ca-713a-b8d7-74d0f3f3f244",
        "storage_key": "property/5752423586988032/019d01a2-a4ca-713a-b8d7-74d0f3f3f244.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "https://cashwise.com/CWstore3046?utm_source=local+listing&utm_medium=organic&utm_campaign=grocery&utm_id=williston",
      "poi_directions_map_url": "https://maps.google.com/?cid=14969500372833607189&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "cash-wise-foods-grocery-store",
      "poi_latitude": "48.1549899",
      "poi_longitude": "-103.6277601",
      "poi_miles_from_property": "1.5 mi",
      "poi_walking_minutes": "33 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 701-572-2927",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5752423586988032/019d01a2-ca0e-7356-8a64-5b199c621a76.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a2-ca0e-7356-8a64-5b199c621a76",
        "storage_key": "property/5752423586988032/019d01a2-ca0e-7356-8a64-5b199c621a76.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJS0DN25hcIVMRFR7T-0ZZvs8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "ec_7cf95f12b5c99d5e066073d4",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5752423586988032",
      "source": "google_places",
      "poi_name": "F & A International Grocery Store",
      "poi_type": "Shopping & Retail",
      "poi_address": "413 Main St #103, Williston, ND 58801, USA",
      "poi_short_description": "Grocery store offering organic and ethnic products, including items from Africa, Asia, and the Caribbean.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5752423586988032/019d01a2-aaaa-744e-a11e-07916b19262d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a2-aaaa-744e-a11e-07916b19262d",
        "storage_key": "property/5752423586988032/019d01a2-aaaa-744e-a11e-07916b19262d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://fandainternationalgrocery.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=287115959149309159&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "f--a-international-grocery-store",
      "poi_latitude": "48.1482429",
      "poi_longitude": "-103.6223907",
      "poi_miles_from_property": "1.9 mi",
      "poi_walking_minutes": "43 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 701-347-8713",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5752423586988032/019d01a2-ca0e-7356-8a64-5b199c621a76.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a2-ca0e-7356-8a64-5b199c621a76",
        "storage_key": "property/5752423586988032/019d01a2-ca0e-7356-8a64-5b199c621a76.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5wiivZhcIVMR56xwknEK_AM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "asian_grocery_store"
    },
    {
      "id": "ec_19702f38ef6f591043d31f20",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5752423586988032",
      "source": "google_places",
      "poi_name": "Genesis",
      "poi_type": "Shopping & Retail",
      "poi_address": "3210 3rd Ave W, Williston, ND 58801, USA",
      "poi_short_description": "Clothing store offering brand-name apparel and footwear, including hats.",
      "poi_long_description": "People say this clothing store offers a wide selection of clothing, shoes, and accessories, including a large selection of running shoes and eyewear. They highlight the helpful and friendly staff, and the excellent customer service. They also like the gift wrapping service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5752423586988032/019d01a2-aa1d-753f-82f7-a861122be6ba.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a2-aa1d-753f-82f7-a861122be6ba",
        "storage_key": "property/5752423586988032/019d01a2-aa1d-753f-82f7-a861122be6ba.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.shopgenesis.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13004001911263652552&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "genesis",
      "poi_latitude": "48.1738433",
      "poi_longitude": "-103.6270751",
      "poi_miles_from_property": "0.6 mi",
      "poi_walking_minutes": "15 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 701-713-4260",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5752423586988032/019d01a2-ca0e-7356-8a64-5777b90f80ed.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a2-ca0e-7356-8a64-5777b90f80ed",
        "storage_key": "property/5752423586988032/019d01a2-ca0e-7356-8a64-5777b90f80ed.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJZSuIz3ZcIVMRyOpeE9d-d7Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "clothing_store"
    },
    {
      "id": "ec_26a13e91b14fb391d0e9c86b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5752423586988032",
      "source": "google_places",
      "poi_name": "Williston State College",
      "poi_type": "Education",
      "poi_address": "1410 University Ave, Williston, ND 58801, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.willistonstate.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11710514784045835372&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "williston-state-college",
      "poi_latitude": "48.1582319",
      "poi_longitude": "-103.6126246",
      "poi_miles_from_property": "1.6 mi",
      "poi_walking_minutes": "34 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 701-774-4200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5752423586988032/019d01a2-cf51-724c-ac1e-5215dca51fc2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a2-cf51-724c-ac1e-5215dca51fc2",
        "storage_key": "property/5752423586988032/019d01a2-cf51-724c-ac1e-5215dca51fc2.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJsaRzp6VcIVMRbCQDsCYbhKI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "ec_160785d0209ffd2d3950f60d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5752423586988032",
      "source": "google_places",
      "poi_name": "Williston Community Library",
      "poi_type": "Education",
      "poi_address": "1302 Davidson Dr, Williston, ND 58801, USA",
      "poi_short_description": "Community library featuring books, events, and programs, plus a bookmobile.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5752423586988032/019d01a2-aa8c-753c-9640-189f18f05096.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a2-aa8c-753c-9640-189f18f05096",
        "storage_key": "property/5752423586988032/019d01a2-aa8c-753c-9640-189f18f05096.webp",
        "width": 960,
        "height": 960
      },
      "poi_business_url": "http://willistonndlibrary.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17956502559896005378&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "williston-community-library",
      "poi_latitude": "48.1567642",
      "poi_longitude": "-103.6389818",
      "poi_miles_from_property": "1.9 mi",
      "poi_walking_minutes": "43 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 701-774-8805",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5752423586988032/019d01a2-cf51-724c-ac1e-5215dca51fc2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a2-cf51-724c-ac1e-5215dca51fc2",
        "storage_key": "property/5752423586988032/019d01a2-cf51-724c-ac1e-5215dca51fc2.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJMQivS4VcIVMRAmv-yvBPMvk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "library"
    },
    {
      "id": "ec_4f2a09adbd631f1f05d9155f",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5752423586988032",
      "source": "google_places",
      "poi_name": "Cut Bluff Overlook",
      "poi_type": "Entertainment",
      "poi_address": "Williston, ND 58801, USA",
      "poi_short_description": "Park featuring an overlook of the Missouri River bottom, picnic tables and an abandoned house.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5752423586988032/019d01a2-aa9a-7498-af97-f57c10fded55.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a2-aa9a-7498-af97-f57c10fded55",
        "storage_key": "property/5752423586988032/019d01a2-aa9a-7498-af97-f57c10fded55.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=4677054207770216042&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "cut-bluff-overlook",
      "poi_latitude": "48.1249125",
      "poi_longitude": "-103.5615183",
      "poi_miles_from_property": "6.0 mi",
      "poi_walking_minutes": "2 hours 10 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5752423586988032/019d01a2-cf4d-733c-a667-e2033aaa6681.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a2-cf4d-733c-a667-e2033aaa6681",
        "storage_key": "property/5752423586988032/019d01a2-cf4d-733c-a667-e2033aaa6681.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJv-jjmdxEIVMRasZjmQU86EA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "historical_landmark"
    },
    {
      "id": "ec_e440170fb2ae32bef6e8a8f2",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5752423586988032",
      "source": "google_places",
      "poi_name": "Ardean Aafedt Stadium",
      "poi_type": "Entertainment",
      "poi_address": "1002 11th St W, Williston, ND 58802, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5752423586988032/019d01a2-afce-7378-b16f-aa09a34fcfa5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a2-afce-7378-b16f-aa09a34fcfa5",
        "storage_key": "property/5752423586988032/019d01a2-afce-7378-b16f-aa09a34fcfa5.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=4516853988177538253&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "ardean-aafedt-stadium",
      "poi_latitude": "48.15603489999999",
      "poi_longitude": "-103.6392175",
      "poi_miles_from_property": "1.9 mi",
      "poi_walking_minutes": "43 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 701-570-4542",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5752423586988032/019d01a2-cf4b-756a-89a3-3a9c50909951.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a2-cf4b-756a-89a3-3a9c50909951",
        "storage_key": "property/5752423586988032/019d01a2-cf4b-756a-89a3-3a9c50909951.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ4w2NNIVcIVMRzeygW8UWrz4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "stadium"
    },
    {
      "id": "ec_8007b740dba928bf774c758d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5752423586988032",
      "source": "google_places",
      "poi_name": "The Frontier Museum",
      "poi_type": "Entertainment",
      "poi_address": "6330 1st Ave W, Williston, ND 58801, USA",
      "poi_short_description": "Visitors can tour a general store, school & church depicting local history since the 19th century.",
      "poi_long_description": "Visitors can tour a general store, school & church depicting local history since the 19th century.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5752423586988032/019d01a2-b0f8-7204-a083-2a3807675ca3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a2-b0f8-7204-a083-2a3807675ca3",
        "storage_key": "property/5752423586988032/019d01a2-b0f8-7204-a083-2a3807675ca3.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.thefrontiermuseum.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1268479469001247800&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-frontier-museum",
      "poi_latitude": "48.203693",
      "poi_longitude": "-103.624705",
      "poi_miles_from_property": "2.5 mi",
      "poi_walking_minutes": "55 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 701-580-2415",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5752423586988032/019d01a2-cf93-7739-8936-7df067fc1e5e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a2-cf93-7739-8936-7df067fc1e5e",
        "storage_key": "property/5752423586988032/019d01a2-cf93-7739-8936-7df067fc1e5e.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJZ57DnzNdIVMROAyyOluLmhE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "ec_63663580a2bdab8ab9ca126d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5752423586988032",
      "source": "google_places",
      "poi_name": "Road of Shame",
      "poi_type": "Entertainment",
      "poi_address": "56th St NW, Harrison Township, ND 58703, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://m.facebook.com/groups/364766625978698/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9069481547846531553&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "road-of-shame",
      "poi_latitude": "48.2344357",
      "poi_longitude": "-103.6040639",
      "poi_miles_from_property": "5.5 mi",
      "poi_walking_minutes": "2 hours 0 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5752423586988032/019d01a2-cf4d-733c-a667-e2033aaa6681.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a2-cf4d-733c-a667-e2033aaa6681",
        "storage_key": "property/5752423586988032/019d01a2-cf4d-733c-a667-e2033aaa6681.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ8xFw0ApDIVMR4TlaZGpF3X0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "historical_landmark"
    },
    {
      "id": "ec_dffc19d4582513eee495c1c8",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5752423586988032",
      "source": "google_places",
      "poi_name": "Phil Rabon Field",
      "poi_type": "Entertainment",
      "poi_address": "1410 University Ave, Williston, ND 58801, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.wsctetons.com/general/2019-20/releases/20190617etn7pc",
      "poi_directions_map_url": "https://maps.google.com/?cid=11226742130829699378&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "phil-rabon-field",
      "poi_latitude": "48.160573",
      "poi_longitude": "-103.6133412",
      "poi_miles_from_property": "1.3 mi",
      "poi_walking_minutes": "29 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 701-774-4200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5752423586988032/019d01a2-cf4b-756a-89a3-3a9c50909951.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a2-cf4b-756a-89a3-3a9c50909951",
        "storage_key": "property/5752423586988032/019d01a2-cf4b-756a-89a3-3a9c50909951.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJZ4lE_69cIVMRMikEdXxmzZs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "stadium"
    },
    {
      "id": "ec_c2098022e8221d7291d822a4",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5752423586988032",
      "source": "google_places",
      "poi_name": "Western Veterinary Clinic",
      "poi_type": "Health and Wellness",
      "poi_address": "14008 W Front St, Williston, ND 58801, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://westernveterinaryclinic.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1441680953766992305&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "western-veterinary-clinic",
      "poi_latitude": "48.1389022",
      "poi_longitude": "-103.7139227",
      "poi_miles_from_property": "5.8 mi",
      "poi_walking_minutes": "2 hours 10 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 701-572-7878",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5752423586988032/019d01a2-cf4d-733c-a667-e2033aaa6681.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a2-cf4d-733c-a667-e2033aaa6681",
        "storage_key": "property/5752423586988032/019d01a2-cf4d-733c-a667-e2033aaa6681.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_Tgvr7JeIVMRsVm6aDDhARQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "veterinary_care"
    },
    {
      "id": "ec_6157bf4ed4600e0dd3473da5",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5752423586988032",
      "source": "google_places",
      "poi_name": "Anytime Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "1542 16th St W, Williston, ND 58801, USA",
      "poi_short_description": "Chain gym featuring cardio and weightlifting equipment, as well as personal training and 24/7 access.",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.anytimefitness.com/locations/williston-north-dakota-778/?utm_source=google&utm_medium=organic-businesslisting&utm_campaign=gbp-listing&utm_content=778",
      "poi_directions_map_url": "https://maps.google.com/?cid=2414718842232582961&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "anytime-fitness",
      "poi_latitude": "48.1592209",
      "poi_longitude": "-103.6468703",
      "poi_miles_from_property": "1.9 mi",
      "poi_walking_minutes": "44 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 701-774-1935",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5752423586988032/019d01a2-cf4d-733c-a667-e2033aaa6681.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a2-cf4d-733c-a667-e2033aaa6681",
        "storage_key": "property/5752423586988032/019d01a2-cf4d-733c-a667-e2033aaa6681.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJh_hD6I5cIVMRMTO3R_7NgiE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "ec_b40b20a801dfeeb494d17d00",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5752423586988032",
      "source": "google_places",
      "poi_name": "Crude Cuts Mens Salon",
      "poi_type": "Health and Wellness",
      "poi_address": "1542 16th St W, Williston, ND 58801, USA",
      "poi_short_description": "Walk-in-friendly salon offering haircuts and beard trims, plus beer.",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://placejack.pw/crude-cuts-mens-salon-b562t7s",
      "poi_directions_map_url": "https://maps.google.com/?cid=13497207398102281502&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "crude-cuts-mens-salon",
      "poi_latitude": "48.15937030000001",
      "poi_longitude": "-103.6467857",
      "poi_miles_from_property": "1.9 mi",
      "poi_walking_minutes": "44 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 701-609-5038",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5752423586988032/019d01a2-cf4d-733c-a667-e2033aaa6681.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a2-cf4d-733c-a667-e2033aaa6681",
        "storage_key": "property/5752423586988032/019d01a2-cf4d-733c-a667-e2033aaa6681.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJnUA3JAldIVMRHi2pB562T7s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hair_salon"
    },
    {
      "id": "ec_f733463f64443f55bd7cfcb9",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5752423586988032",
      "source": "google_places",
      "poi_name": "Platinum Blades For Men",
      "poi_type": "Health and Wellness",
      "poi_address": "2112 4th Ave W, Williston, ND 58801, USA",
      "poi_short_description": "Barbershop offering services such as fades and beard trims in an inviting setting.",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://platinumbladesformen.booksy.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1149626637495355172&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "platinum-blades-for-men",
      "poi_latitude": "48.1639698",
      "poi_longitude": "-103.6284641",
      "poi_miles_from_property": "0.9 mi",
      "poi_walking_minutes": "21 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 701-895-8333",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5752423586988032/019d01a2-cf4d-733c-a667-e2033aaa6681.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a2-cf4d-733c-a667-e2033aaa6681",
        "storage_key": "property/5752423586988032/019d01a2-cf4d-733c-a667-e2033aaa6681.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJhUocGU_r9YoRJMc8-FVL9A8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "barber_shop"
    },
    {
      "id": "ec_74db0d1d1c51e9f2a399e1de",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5752423586988032",
      "source": "google_places",
      "poi_name": "ManCave for Men",
      "poi_type": "Health and Wellness",
      "poi_address": "3210 27th St W #107, Williston, ND 58801, USA",
      "poi_short_description": "Barbershop for men offering haircuts, beard trims, and head shaves, plus beer.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5752423586988032/019d01a2-b0ea-7050-9e68-39a089dedd94.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a2-b0ea-7050-9e68-39a089dedd94",
        "storage_key": "property/5752423586988032/019d01a2-b0ea-7050-9e68-39a089dedd94.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.mancaveformen.com/locations/williston-north-dakota/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7247546321586758329&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "mancave-for-men",
      "poi_latitude": "48.1701697",
      "poi_longitude": "-103.670304",
      "poi_miles_from_property": "2.8 mi",
      "poi_walking_minutes": "1 hour 6 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 701-609-5024",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5752423586988032/019d01a2-cf4d-733c-a667-e2033aaa6681.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a2-cf4d-733c-a667-e2033aaa6681",
        "storage_key": "property/5752423586988032/019d01a2-cf4d-733c-a667-e2033aaa6681.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ61CY3ahdIVMRuSJe9_p0lGQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "barber_shop"
    },
    {
      "id": "ec_dbaef4082dcd2df0040cc66e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5752423586988032",
      "source": "google_places",
      "poi_name": "The Pitt, House of Gainz",
      "poi_type": "Health and Wellness",
      "poi_address": "1316 2nd Ave W, Williston, ND 58801, USA",
      "poi_short_description": "Gym with fitness equipment for all levels, plus supplements and protein shakes.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5752423586988032/019d01a2-b161-747c-b9a9-3deb58c425ff.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a2-b161-747c-b9a9-3deb58c425ff",
        "storage_key": "property/5752423586988032/019d01a2-b161-747c-b9a9-3deb58c425ff.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://m.facebook.com/pages/category/Athlete/The-Pitt-House-of-Gainz-1851029195011498/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6932556999317617756&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-pitt-house-of-gainz",
      "poi_latitude": "48.1573813",
      "poi_longitude": "-103.62532",
      "poi_miles_from_property": "1.3 mi",
      "poi_walking_minutes": "28 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 701-774-1101",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5752423586988032/019d01a2-cf4d-733c-a667-e2033aaa6681.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a2-cf4d-733c-a667-e2033aaa6681",
        "storage_key": "property/5752423586988032/019d01a2-cf4d-733c-a667-e2033aaa6681.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_cispkpdIVMRXHx5UdxjNWA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "ec_fba6865850bd687ab8020b4e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5752423586988032",
      "source": "google_places",
      "poi_name": "OMG Nails",
      "poi_type": "Health and Wellness",
      "poi_address": "4315 9th Ave W Ste 423, Williston, ND 58801, USA",
      "poi_short_description": "Nail salon within the Badlands Town Center providing a restroom.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5752423586988032/019d01a2-b54e-7347-82c4-052a20ac53a2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a2-b54e-7347-82c4-052a20ac53a2",
        "storage_key": "property/5752423586988032/019d01a2-b54e-7347-82c4-052a20ac53a2.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://booking.gocheckin.net/v2/17161",
      "poi_directions_map_url": "https://maps.google.com/?cid=992831187649875150&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "omg-nails",
      "poi_latitude": "48.1844371",
      "poi_longitude": "-103.6379623",
      "poi_miles_from_property": "1.7 mi",
      "poi_walking_minutes": "39 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 701-609-5581",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5752423586988032/019d01a2-cf4d-733c-a667-e2033aaa6681.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a2-cf4d-733c-a667-e2033aaa6681",
        "storage_key": "property/5752423586988032/019d01a2-cf4d-733c-a667-e2033aaa6681.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJXw752JRdIVMRzszMdbQ-xw0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "nail_salon"
    },
    {
      "id": "ec_01d2293f97a3cafee5cda258",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5752423586988032",
      "source": "google_places",
      "poi_name": "Jason's Barber Shop",
      "poi_type": "Health and Wellness",
      "poi_address": "721 E Highland Dr #C, Williston, ND 58801, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5752423586988032/019d01a2-b650-7328-bf04-cd17cfbce276.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a2-b650-7328-bf04-cd17cfbce276",
        "storage_key": "property/5752423586988032/019d01a2-b650-7328-bf04-cd17cfbce276.webp",
        "width": 497,
        "height": 373
      },
      "poi_business_url": "http://jasonsbarbershopnd.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4875187328603086019&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "jasons-barber-shop",
      "poi_latitude": "48.1562559",
      "poi_longitude": "-103.609949",
      "poi_miles_from_property": "1.8 mi",
      "poi_walking_minutes": "40 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 701-609-5080",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5752423586988032/019d01a2-cf4d-733c-a667-e2033aaa6681.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a2-cf4d-733c-a667-e2033aaa6681",
        "storage_key": "property/5752423586988032/019d01a2-cf4d-733c-a667-e2033aaa6681.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJx_JFNK9cIVMRw1zfpgslqEM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "barber_shop"
    },
    {
      "id": "ec_90d9e6aebc4a6ff34df53712",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5752423586988032",
      "source": "google_places",
      "poi_name": "Bakken Mobile Vet",
      "poi_type": "Health and Wellness",
      "poi_address": "1301 24th St W, Williston, ND 58801, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5752423586988032/019d01a2-b65a-75e3-a05f-ad398dbc213d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a2-b65a-75e3-a05f-ad398dbc213d",
        "storage_key": "property/5752423586988032/019d01a2-b65a-75e3-a05f-ad398dbc213d.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://myweb13.site/explore/bakken-mobile-vet",
      "poi_directions_map_url": "https://maps.google.com/?cid=4510289985865163046&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "bakken-mobile-vet",
      "poi_latitude": "48.1662406",
      "poi_longitude": "-103.6422882",
      "poi_miles_from_property": "1.5 mi",
      "poi_walking_minutes": "35 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 701-570-5510",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5752423586988032/019d01a2-cf4d-733c-a667-e2033aaa6681.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a2-cf4d-733c-a667-e2033aaa6681",
        "storage_key": "property/5752423586988032/019d01a2-cf4d-733c-a667-e2033aaa6681.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-aj397hcIVMRJqF-edjElz4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "veterinary_care"
    },
    {
      "id": "ec_776b09a76596ddcf0a8afc7a",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5752423586988032",
      "source": "google_places",
      "poi_name": "LGND CUTS",
      "poi_type": "Health and Wellness",
      "poi_address": "612 4th St E, Williston, ND 58801, USA",
      "poi_short_description": "Kid-friendly, clean salon offering haircuts, fades and styles, plus beard trims and nose waxing.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5752423586988032/019d01a2-b69f-71ed-a26d-fbdfc1da594b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a2-b69f-71ed-a26d-fbdfc1da594b",
        "storage_key": "property/5752423586988032/019d01a2-b69f-71ed-a26d-fbdfc1da594b.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://lgndcuts.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3769342581426349636&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "lgnd-cuts",
      "poi_latitude": "48.1476827",
      "poi_longitude": "-103.6130776",
      "poi_miles_from_property": "2.3 mi",
      "poi_walking_minutes": "50 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 701-580-9233",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5752423586988032/019d01a2-cf4d-733c-a667-e2033aaa6681.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a2-cf4d-733c-a667-e2033aaa6681",
        "storage_key": "property/5752423586988032/019d01a2-cf4d-733c-a667-e2033aaa6681.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJGUWjJ1lbIVMRROarYhtlTzQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "barber_shop"
    },
    {
      "id": "ec_42b1fe0ac98a35e50a599816",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5752423586988032",
      "source": "google_places",
      "poi_name": "CHI St. Alexius Health Williston Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "1301 15th Ave W, Williston, ND 58801, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5752423586988032/019d01a2-ba6a-736a-bd8a-05151446bcb3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a2-ba6a-736a-bd8a-05151446bcb3",
        "storage_key": "property/5752423586988032/019d01a2-ba6a-736a-bd8a-05151446bcb3.webp",
        "width": 720,
        "height": 405
      },
      "poi_business_url": "https://www.chistalexiushealth.org/locations/williston",
      "poi_directions_map_url": "https://maps.google.com/?cid=18263497799483371781&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "chi-st-alexius-health-williston-medical-center",
      "poi_latitude": "48.155689",
      "poi_longitude": "-103.6456821",
      "poi_miles_from_property": "2.2 mi",
      "poi_walking_minutes": "50 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 701-572-7651",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5752423586988032/019d01a2-d324-7258-bd5d-8ac83e2a1e3f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a2-d324-7258-bd5d-8ac83e2a1e3f",
        "storage_key": "property/5752423586988032/019d01a2-d324-7258-bd5d-8ac83e2a1e3f.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJUWyH2IVcIVMRBbFVBnz6dP0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "ec_913d0271cc44d2dc3c332d14",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5752423586988032",
      "source": "google_places",
      "poi_name": "Spring Lake Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Spring Lake Park, 5906 2nd Ave W Building A, Williston, ND 58801, USA",
      "poi_short_description": "Public park with children's facilities, a dog park, maze & direct access to the lake.",
      "poi_long_description": "People say this park offers stunning lake views, walking paths, a playground, and open spaces for picnics. They highlight the peaceful and relaxing vibe, perfect for unwinding, watching ducks, or fishing. They also like the well-maintained grounds and the Christmas light display.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5752423586988032/019d01a2-bab7-72ad-9ac8-416db362bc86.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a2-bab7-72ad-9ac8-416db362bc86",
        "storage_key": "property/5752423586988032/019d01a2-bab7-72ad-9ac8-416db362bc86.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.willistonparks.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9677238210427773620&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "spring-lake-park",
      "poi_latitude": "48.2018042",
      "poi_longitude": "-103.618575",
      "poi_miles_from_property": "2.5 mi",
      "poi_walking_minutes": "55 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 701-774-9773",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5752423586988032/019d01a2-d324-7258-bd5d-87914baecb66.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a2-d324-7258-bd5d-87914baecb66",
        "storage_key": "property/5752423586988032/019d01a2-d324-7258-bd5d-87914baecb66.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJQ6J6tDJdIVMRtGJiU-F0TIY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_50838f8d6767c0554a0fe0b3",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5752423586988032",
      "source": "google_places",
      "poi_name": "Eagle Ridge Golf Club",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "6401 3rd Ave E Suite 1, Williston, ND 58801, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5752423586988032/019d01a2-bbe0-740d-9a3a-da62b8bb0e55.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a2-bbe0-740d-9a3a-da62b8bb0e55",
        "storage_key": "property/5752423586988032/019d01a2-bbe0-740d-9a3a-da62b8bb0e55.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://eagleridgewilliston.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10920535095398698400&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "eagle-ridge-golf-club",
      "poi_latitude": "48.2039772",
      "poi_longitude": "-103.6093962",
      "poi_miles_from_property": "3.1 mi",
      "poi_walking_minutes": "1 hour 9 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 701-572-6500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5752423586988032/019d01a2-d31b-75fa-9a27-85a31b030e25.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a2-d31b-75fa-9a27-85a31b030e25",
        "storage_key": "property/5752423586988032/019d01a2-d31b-75fa-9a27-85a31b030e25.webp",
        "width": 132,
        "height": 192
      },
      "poi_google_place_id": "ChIJdWfz_5ZdIVMRoA1tTs-IjZc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "golf_course"
    },
    {
      "id": "ec_e8f19cde948b57a64d9bd6f2",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5752423586988032",
      "source": "google_places",
      "poi_name": "Davidson Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "11th St W & 9th Ave W, Williston, ND 58801, USA",
      "poi_short_description": "Popular haunt with tennis courts, a playground, a seasonal splash pad & picnic areas.",
      "poi_long_description": "People say this park offers a splash pad, playground, library, baseball field, and tennis courts. They highlight the clean, well-maintained green space, peaceful walking trails, and safe playground. They also like the picnic areas, pet-friendly environment, and suitability for families and gatherings.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5752423586988032/019d01a2-bc6b-774c-b849-f84440cc2e81.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a2-bc6b-774c-b849-f84440cc2e81",
        "storage_key": "property/5752423586988032/019d01a2-bc6b-774c-b849-f84440cc2e81.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.willistonparks.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6469649249667375170&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "davidson-park",
      "poi_latitude": "48.1560681",
      "poi_longitude": "-103.6406368",
      "poi_miles_from_property": "1.9 mi",
      "poi_walking_minutes": "43 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 701-774-9773",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5752423586988032/019d01a2-d324-7258-bd5d-87914baecb66.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a2-d324-7258-bd5d-87914baecb66",
        "storage_key": "property/5752423586988032/019d01a2-d324-7258-bd5d-87914baecb66.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJGce3Q4VcIVMRQuDLA7fPyFk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_c1776593bd2c99be4e9ff800",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5752423586988032",
      "source": "google_places",
      "poi_name": "Western Star Complex",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1600 19th Ave W, Williston, ND 58801, USA",
      "poi_short_description": "Family-friendly park featuring a ball field, playground, and ice rink.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5752423586988032/019d01a2-bf60-72f9-be5e-1e5ec7afea07.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a2-bf60-72f9-be5e-1e5ec7afea07",
        "storage_key": "property/5752423586988032/019d01a2-bf60-72f9-be5e-1e5ec7afea07.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.willistonparks.com/parks",
      "poi_directions_map_url": "https://maps.google.com/?cid=684879181734047739&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "western-star-complex",
      "poi_latitude": "48.1594034",
      "poi_longitude": "-103.6501259",
      "poi_miles_from_property": "2.1 mi",
      "poi_walking_minutes": "49 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 701-774-9773",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5752423586988032/019d01a2-d324-7258-bd5d-87914baecb66.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a2-d324-7258-bd5d-87914baecb66",
        "storage_key": "property/5752423586988032/019d01a2-d324-7258-bd5d-87914baecb66.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJp3_5AolcIVMR-29RtfwtgQk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_e938a656a33bf09f07d5e30c",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5752423586988032",
      "source": "google_places",
      "poi_name": "Williston Municipal Golf Course",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "3401 42nd St W, Williston, ND 58801, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5752423586988032/019d01a2-c069-767f-9fb8-57cb88b10bd4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a2-c069-767f-9fb8-57cb88b10bd4",
        "storage_key": "property/5752423586988032/019d01a2-c069-767f-9fb8-57cb88b10bd4.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.willistonparks.com/williston-municipal-golf-course",
      "poi_directions_map_url": "https://maps.google.com/?cid=4183863530093376763&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "williston-municipal-golf-course",
      "poi_latitude": "48.1842994",
      "poi_longitude": "-103.6668777",
      "poi_miles_from_property": "2.9 mi",
      "poi_walking_minutes": "1 hour 7 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 701-577-1321",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5752423586988032/019d01a2-d31b-75fa-9a27-85a31b030e25.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a2-d31b-75fa-9a27-85a31b030e25",
        "storage_key": "property/5752423586988032/019d01a2-d31b-75fa-9a27-85a31b030e25.webp",
        "width": 132,
        "height": 192
      },
      "poi_google_place_id": "ChIJuRYDveNcIVMR-3Ttq7YREDo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "golf_course"
    },
    {
      "id": "ec_33c3f2f566b37f26313459b2",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5752423586988032",
      "source": "google_places",
      "poi_name": "Williston",
      "poi_type": "Transportation & Transit",
      "poi_address": "1 S Main St, Williston, ND 58801, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5752423586988032/019d01a2-c2e3-720d-b828-40e0bd9ffe93.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a2-c2e3-720d-b828-40e0bd9ffe93",
        "storage_key": "property/5752423586988032/019d01a2-c2e3-720d-b828-40e0bd9ffe93.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.amtrak.com/servlet/ContentServer?pagename=am/am2Station/Station_Page&code=WTN",
      "poi_directions_map_url": "https://maps.google.com/?cid=17774109292604435739&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "williston",
      "poi_latitude": "48.142851",
      "poi_longitude": "-103.6211029",
      "poi_miles_from_property": "2.3 mi",
      "poi_walking_minutes": "51 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 800-872-7245",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5752423586988032/019d01a2-d33b-728f-9573-d0c1f3242435.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a2-d33b-728f-9573-d0c1f3242435",
        "storage_key": "property/5752423586988032/019d01a2-d33b-728f-9573-d0c1f3242435.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJrz7HPmdbIVMRGy2o-DpSqvY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "train_station"
    },
    {
      "id": "ec_2a21f0c96bb831755f19f3fa",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5752423586988032",
      "source": "google_places",
      "poi_name": "SLB",
      "poi_type": "Major Employers & Offices",
      "poi_address": "301 60th Ave W, Williston, ND 58801, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5752423586988032/019d01a2-c2fb-75ed-a757-4ff34afa5cbd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a2-c2fb-75ed-a757-4ff34afa5cbd",
        "storage_key": "property/5752423586988032/019d01a2-c2fb-75ed-a757-4ff34afa5cbd.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.slb.com/about.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=9023311671045616700&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "slb",
      "poi_latitude": "48.1462858",
      "poi_longitude": "-103.707019",
      "poi_miles_from_property": "5.8 mi",
      "poi_walking_minutes": "2 hours 9 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 701-572-1200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5752423586988032/019d01a2-cf4d-733c-a667-e2033aaa6681.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a2-cf4d-733c-a667-e2033aaa6681",
        "storage_key": "property/5752423586988032/019d01a2-cf4d-733c-a667-e2033aaa6681.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJOcHTUF5bIVMRPHRPQig-OX0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "ec_f758dd11c6f62c39da613f88",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5752423586988032",
      "source": "google_places",
      "poi_name": "Agri Industries, Inc. - Williston",
      "poi_type": "Major Employers & Offices",
      "poi_address": "3105 2nd St W, Williston, ND 58801, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5752423586988032/019d01a2-c40d-70ec-b375-9f22b29138fc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a2-c40d-70ec-b375-9f22b29138fc",
        "storage_key": "property/5752423586988032/019d01a2-c40d-70ec-b375-9f22b29138fc.webp",
        "width": 1280,
        "height": 875
      },
      "poi_business_url": "http://www.agriindustries.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15841918621575738094&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "agri-industries-inc---williston",
      "poi_latitude": "48.1420627",
      "poi_longitude": "-103.6679913",
      "poi_miles_from_property": "3.8 mi",
      "poi_walking_minutes": "1 hour 25 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 701-572-0767",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5752423586988032/019d01a2-cf4d-733c-a667-e2033aaa6681.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a2-cf4d-733c-a667-e2033aaa6681",
        "storage_key": "property/5752423586988032/019d01a2-cf4d-733c-a667-e2033aaa6681.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJhUdjNIpbIVMR7vKqXw3N2ds",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "ec_527d0db40b7dd19550c874a0",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5752423586988032",
      "source": "google_places",
      "poi_name": "Spydr Oilfield Service",
      "poi_type": "Major Employers & Offices",
      "poi_address": "5309 Saddle Ridge Cir Unit F, Williston, ND 58801, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5752423586988032/019d01a2-c62d-74aa-82c9-1566c031c5df.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a2-c62d-74aa-82c9-1566c031c5df",
        "storage_key": "property/5752423586988032/019d01a2-c62d-74aa-82c9-1566c031c5df.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=18433282211163594255&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "spydr-oilfield-service",
      "poi_latitude": "48.1930625",
      "poi_longitude": "-103.6616936",
      "poi_miles_from_property": "3.1 mi",
      "poi_walking_minutes": "1 hour 11 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 701-774-2340",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5752423586988032/019d01a2-cf4d-733c-a667-e2033aaa6681.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a2-cf4d-733c-a667-e2033aaa6681",
        "storage_key": "property/5752423586988032/019d01a2-cf4d-733c-a667-e2033aaa6681.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7W5oqwVdIVMRD97u4IEs0P8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    }
  ],
  "office_hours": [
    {
      "id": "ec_ae45741c00619bb6c535d277",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5752423586988032",
      "day": "MON",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_a9d82671ad4be6fb0f5a3477",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5752423586988032",
      "day": "TUE",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_a5c83997b3099621a2a39101",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5752423586988032",
      "day": "WED",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_44947708ff5b4fd9d2987d8a",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5752423586988032",
      "day": "THU",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_7f1916cdfee9cb04405286ea",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5752423586988032",
      "day": "FRI",
      "open_time": "10:00",
      "close_time": "18:00"
    }
  ],
  "reviews": [
    {
      "id": "custom_e02a0cfd-8d83-4371-83a6-dd672484309d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5752423586988032",
      "rating": "5.0",
      "name": "Marijene Fenlason",
      "text": "Jayden is fantastic! Very professional, knowledgeable, and amazing! He was so helpful and kind! Jayden was so proud of our complex, it was refreshing to see!  He loves his job and shows it!  He was amazing with our dog!!  Thank you Jayden!  I truly appreciate you!",
      "date": "2025-03-14",
      "title": ""
    },
    {
      "id": "custom_cdfbf21f-a522-47a0-99ea-b9c5781cdec2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5752423586988032",
      "rating": "5.0",
      "name": "Neuski",
      "text": "I was looking for an apartment home to move into with a buddy this recent month and I am incredibly happy I stumbled across Dakota Commons! Great move in experience, everyone was nice to me, and rent is very affordable for the experience and quality of these apartment homes. They come with a garage that is directly attached to the apartment building so this is great during the winter. I would highly recommend checking these guys out, they are worth your time and every penny!",
      "date": "2020-09-21",
      "title": ""
    }
  ],
  "virtual_tours": [],
  "faqs": [],
  "pet_policies": [
    {
      "id": "ec_9b83b0de05d387974227e5b9",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5752423586988032",
      "source": "yardi",
      "external_id": "2512155",
      "pet_type": "cats",
      "allowed": true,
      "max_count": 2,
      "weight_limit": 0,
      "deposit": 250,
      "fee": 250,
      "monthly_rent": 35,
      "description": "Up to 2 pets per home are welcome.",
      "restrictions": "false"
    },
    {
      "id": "ec_c44283ed1aec0b0a19d3448d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5752423586988032",
      "source": "yardi",
      "external_id": "2512154",
      "pet_type": "dogs",
      "allowed": true,
      "max_count": 2,
      "weight_limit": 50,
      "deposit": 250,
      "fee": 250,
      "monthly_rent": 35,
      "description": "Up to 2 pets per home are welcome.",
      "restrictions": "Breed restrictions apply"
    }
  ],
  "lead_collectors": [
    {
      "lead_collector_id": "0198aa47-03ed-72e6-b726-3c478ae0ce74",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "dakota-commons-apartment-homes",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5752423586988032"
    },
    {
      "lead_collector_id": "0198aa47-044f-758a-9f27-09eb5fb2ec35",
      "lead_source": "FACEBOOK_ADS",
      "name": "dakota-commons-apartment-homes",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5752423586988032"
    },
    {
      "lead_collector_id": "0198aa47-04b2-72e8-a008-e8d9ea8a923e",
      "lead_source": "LANDING_PAGE",
      "name": "dakota-commons-apartment-homes",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5752423586988032"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5752423586988032",
      "source": "generator",
      "page_item_url": "pet-friendly-apartments-williston-nd",
      "search_query": "pet friendly apartments Williston ND",
      "category": "Amenity",
      "h1_title": "Pet-Friendly Living in Williston, ND",
      "h2_subtitle": "Discover pet friendly apartments in Williston, ND at Dakota Commons. Our community welcomes furry friends with open arms and spacious accommodations.",
      "page_copy": "Welcome to Dakota Commons Apartment Homes where pet lovers will find an inviting community in Williston, ND. Our pet friendly apartments offer the ideal setting for both you and your furry companions. Whether you're playing in our open spaces or relaxing together in our expansive units, you'll feel right at home.\n\nExplore the convenience of having online services at your fingertips and the assurance of on-site maintenance. At Dakota Commons, air-conditioned living combines with a perfect location to ensure every day is stress-free. Find the best pet friendly apartments Williston, ND has to offer, and make Dakota Commons your home today!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5752423586988032/019d01a2-2782-758a-bfcf-2c5143d6b58d.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with dark wood cabinets, stainless steel appliances, and an island with a breakfast bar.",
        "public_id": "019d01a2-2782-758a-bfcf-2c5143d6b58d",
        "storage_key": "property/5752423586988032/019d01a2-2782-758a-bfcf-2c5143d6b58d.webp",
        "width": 2560,
        "height": 1707
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Pet-Friendly Living in Williston, ND",
      "seo_description": "Discover pet friendly apartments at Dakota Commons in Williston, ND. Spacious living for you and your pets!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5752423586988032",
      "source": "generator",
      "page_item_url": "spacious-floorplans-williston-apartments",
      "search_query": "spacious floorplans Williston apartments",
      "category": "Amenity",
      "h1_title": "Spacious Floorplans in Williston",
      "h2_subtitle": "Explore our spacious floorplans at Dakota Commons, offering one, two, and three-bedroom options in Williston apartments.",
      "page_copy": "At Dakota Commons Apartment Homes in Williston, ND, you'll discover a variety of spacious floorplans designed to suit any lifestyle. Our community features one, two, and three-bedroom apartments, providing ample room to live comfortably. Each apartment comes with thoughtful layouts that maximize both living and storage space.\n\nYour convenience is our priority with amenities like air conditioning ports and online service requests. Dakota Commons not only offers spacious floorplans but also a friendly community atmosphere. Treat yourself to the luxury of space and make Dakota Commons your new home in Williston.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5752423586988032/019d01a2-2782-758a-bfcf-2c5143d6b58d.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with dark wood cabinets, stainless steel appliances, and an island with a breakfast bar.",
        "public_id": "019d01a2-2782-758a-bfcf-2c5143d6b58d",
        "storage_key": "property/5752423586988032/019d01a2-2782-758a-bfcf-2c5143d6b58d.webp",
        "width": 2560,
        "height": 1707
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Spacious Floorplans in Williston",
      "seo_description": "Find spacious floorplans at Dakota Commons Williston apartments. Choose from large 1, 2, or 3-bedroom layouts!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5752423586988032",
      "source": "generator",
      "page_item_url": "apartments-with-walk-in-closets-williston",
      "search_query": "apartments with walk-in closets in Williston",
      "category": "Amenity",
      "h1_title": "Walk-In Closets in Williston Apartments",
      "h2_subtitle": "Discover apartments with walk-in closets in Williston at Dakota Commons. Enjoy ample storage solutions and modern amenities.",
      "page_copy": "At Dakota Commons Apartment Homes, experience the luxury of apartments with walk-in closets in Williston, ND. Our spacious floorplans ensure plenty of room for all your storage needs, offering an organized and clutter-free living environment. Each apartment is thoughtfully designed to provide maximum comfort and convenience, featuring modern amenities like air conditioning ports.\n\nIn addition to walk-in closets, Dakota Commons enhances your living experience with pet-friendly policies and online services, including payment and maintenance requests. Nestled in a welcoming community, our apartments cater to diverse lifestyles, helping you create a home that's both practical and stylish.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5752423586988032/019d01a2-2782-758a-bfcf-2c5143d6b58d.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with dark wood cabinets, stainless steel appliances, and an island with a breakfast bar.",
        "public_id": "019d01a2-2782-758a-bfcf-2c5143d6b58d",
        "storage_key": "property/5752423586988032/019d01a2-2782-758a-bfcf-2c5143d6b58d.webp",
        "width": 2560,
        "height": 1707
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Walk-In Closets in Williston Apartments",
      "seo_description": "Explore Dakota Commons for apartments with walk-in closets in Williston. Enjoy spacious living with modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5752423586988032",
      "source": "generator",
      "page_item_url": "air-conditioned-apartments-williston-58801",
      "search_query": "air conditioned apartments Williston 58801",
      "category": "Amenity",
      "h1_title": "Air Conditioned Comfort in Williston, 58801",
      "h2_subtitle": "Explore air conditioned apartments in Williston, 58801 at Dakota Commons. Stay cool and comfortable year-round with our modern amenities.",
      "page_copy": "Welcome to Dakota Commons Apartment Homes, where you'll find expertly designed air conditioned apartments in Williston, ND, 58801. Our community boasts a range of spacious layouts, all equipped with air conditioning ports to ensure you stay comfortable no matter the season.\n\nBesides providing a cool escape during warmer months, Dakota Commons enhances apartment living with additional conveniences like online payments and service requests. Located in a vibrant Williston neighborhood, our pet-friendly community is committed to providing residents with a harmonious living experience. Choose Dakota Commons for modern air conditioned comfort and more.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5752423586988032/019d01a2-2782-758a-bfcf-2c5143d6b58d.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with dark wood cabinets, stainless steel appliances, and an island with a breakfast bar.",
        "public_id": "019d01a2-2782-758a-bfcf-2c5143d6b58d",
        "storage_key": "property/5752423586988032/019d01a2-2782-758a-bfcf-2c5143d6b58d.webp",
        "width": 2560,
        "height": 1707
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Air Conditioned Comfort in Williston, 58801",
      "seo_description": "Discover air conditioned apartments in Williston, 58801, at Dakota Commons. Enjoy modern living and comfort year-round.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5752423586988032",
      "source": "generator",
      "page_item_url": "washer-laundry-rooms-williston-nd",
      "search_query": "washer and laundry rooms Williston ND",
      "category": "Amenity",
      "h1_title": "Washer and Laundry Rooms in Williston, ND",
      "h2_subtitle": "Find convenient washer and laundry rooms in Williston, ND, at Dakota Commons. Simplify your laundry routine with ease.",
      "page_copy": "Dakota Commons Apartment Homes in Williston, ND, offers residents the utmost convenience with access to washer and laundry rooms, making laundry day a breeze. Our community's dedicated laundry spaces are designed to provide residents with efficient and hassle-free washing and drying solutions.\n\nIn addition to the practicality of our laundry rooms, Dakota Commons provides spacious floorplans with modern amenities, including air conditioning ports and online service requests. Our pet-friendly apartments are nestled in a welcoming Williston neighborhood, perfect for those seeking comfort and convenience. Enjoy a simplified lifestyle at Dakota Commons.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5752423586988032/019d01a2-2782-758a-bfcf-2c5143d6b58d.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with dark wood cabinets, stainless steel appliances, and an island with a breakfast bar.",
        "public_id": "019d01a2-2782-758a-bfcf-2c5143d6b58d",
        "storage_key": "property/5752423586988032/019d01a2-2782-758a-bfcf-2c5143d6b58d.webp",
        "width": 2560,
        "height": 1707
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Washer and Laundry Rooms in Williston, ND",
      "seo_description": "Explore Dakota Commons for washer and laundry rooms in Williston, ND. Experience convenient laundry solutions and modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5752423586988032",
      "source": "generator",
      "page_item_url": "one-bedroom-apartments-williston-nd",
      "search_query": "one bedroom apartments in Williston ND",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments in Williston, ND",
      "h2_subtitle": "Explore one bedroom apartments in Williston, ND, at Dakota Commons. Enjoy cozy living with modern amenities designed for comfort.",
      "page_copy": "Discover the perfect one bedroom apartments in Williston, ND, at Dakota Commons Apartment Homes. Our thoughtfully designed floorplans offer a blend of comfort and style, providing ample space for singles or couples looking for a cozy living environment. Each apartment is equipped with essential features like air conditioning ports, ensuring year-round comfort.\n\nDakota Commons goes beyond traditional apartment living by offering convenient online services such as payments and maintenance requests, alongside being a pet-friendly community. Situated in the heart of Williston, ND, our one bedroom apartments provide the ideal combination of modern living and neighborhood charm. Make Dakota Commons your new home today!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5752423586988032/019d01a2-2782-758a-bfcf-2c5143d6b58d.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with dark wood cabinets, stainless steel appliances, and an island with a breakfast bar.",
        "public_id": "019d01a2-2782-758a-bfcf-2c5143d6b58d",
        "storage_key": "property/5752423586988032/019d01a2-2782-758a-bfcf-2c5143d6b58d.webp",
        "width": 2560,
        "height": 1707
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartments in Williston, ND",
      "seo_description": "Explore Dakota Commons for one bedroom apartments in Williston, ND. Enjoy modern amenities in a welcoming community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5752423586988032",
      "source": "generator",
      "page_item_url": "two-bedroom-apartments-williams-county",
      "search_query": "two bedroom apartments in Williams County",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Apartments in Williams County",
      "h2_subtitle": "Discover two bedroom apartments in Williams County at Dakota Commons. Experience spacious layouts designed for comfort and convenience.",
      "page_copy": "Discover exceptional two bedroom apartments in Williams County at Dakota Commons Apartment Homes. Our spacious floorplans are perfect for small families or roommates seeking a balance of comfort and modern living. Residents enjoy features like air conditioning ports that ensure a pleasant atmosphere all year long.\n\nBeyond just living space, Dakota Commons offers a range of convenient amenities, such as online payment options and quick service requests, making daily life simpler. As a pet-friendly community, Dakota Commons is dedicated to providing a welcoming environment where residents and their pets can thrive together. Visit us in the heart of Williams County and find your ideal home today!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5752423586988032/019d01a2-2782-758a-bfcf-2c5143d6b58d.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with dark wood cabinets, stainless steel appliances, and an island with a breakfast bar.",
        "public_id": "019d01a2-2782-758a-bfcf-2c5143d6b58d",
        "storage_key": "property/5752423586988032/019d01a2-2782-758a-bfcf-2c5143d6b58d.webp",
        "width": 2560,
        "height": 1707
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Apartments in Williams County",
      "seo_description": "Explore two bedroom apartments in Williams County at Dakota Commons. Enjoy spacious living and modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5752423586988032",
      "source": "generator",
      "page_item_url": "three-bedroom-apartments-near-58801",
      "search_query": "three bedroom apartments near 58801",
      "category": "Floorplan",
      "h1_title": "Three Bedroom Apartments Near 58801",
      "h2_subtitle": "Explore three bedroom apartments near 58801 at Dakota Commons. Perfect for families seeking space and modern amenities.",
      "page_copy": "Looking for spacious three bedroom apartments near 58801? Dakota Commons Apartment Homes offers ample living space ideal for families or those needing extra room. Each apartment is designed with comfort in mind, featuring thoughtful layouts that accommodate your lifestyle while maximizing functionality.\n\nAt Dakota Commons, residents enjoy a range of amenities, including air conditioning ports and efficient online services like payments and maintenance requests. As a pet-friendly community located just outside Williston, ND, apartment seekers will find Dakota Commons an inviting place to call home. Experience the convenience and comfort of living close to everything you need in the 58801 area.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5752423586988032/019d01a2-2782-758a-bfcf-2c5143d6b58d.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with dark wood cabinets, stainless steel appliances, and an island with a breakfast bar.",
        "public_id": "019d01a2-2782-758a-bfcf-2c5143d6b58d",
        "storage_key": "property/5752423586988032/019d01a2-2782-758a-bfcf-2c5143d6b58d.webp",
        "width": 2560,
        "height": 1707
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Three Bedroom Apartments Near 58801",
      "seo_description": "Discover spacious three bedroom apartments near 58801 at Dakota Commons. Ideal for families, featuring modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "bobbi@repli360.com"
    },
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "4724"
    },
    {
      "ID": "custom_pixel_id",
      "type": "STRING",
      "value": "1035508496598043"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "9147445529"
    },
    {
      "ID": "custom_text_us_url",
      "type": "STRING",
      "value": "https://popcard.rentcafe.com/TextUsWidget.aspx?dnis=7012040018"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-55Z9L9TP"
    },
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "Phase 8"
    },
    {
      "ID": "custom_vibesites_theme",
      "type": "STRING",
      "value": "Comfy"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_rentcafe_chatbot",
      "type": "STRING",
      "value": "<script type=\"text/javascript\" src=\"//webchat.omni.cafe/conversations/dfa8c2c4-987a-4f92-ae88-be4591c9d849/app.js?property=dfa8c2c4-987a-4f92-ae88-be4591c9d849&propertyName=Dakota+Commons+Apartment+Homes&channelUuid=c248ebd9-8dac-11ec-afb4-42010aa42b&buttonbgcolor=012345\" defer></script>"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "47745296913"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "turnkey"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6Ii91ZjlsY05seTRYclhwVHZsNTAvanc9PSIsInZhbHVlIjoic3hWWWNFVEp6ZFA5ZWZjWHB0cnVHdz09IiwibWFjIjoiZmM3N2VjNjc5MzhlYTk3YTlmMmRjNjA2ZWMzZTlkMTQyMWMxMTc3MWE2YjE5NzBkZDJjOTU5MjM4M2Y2YzVmYyJ9"
    }
  ],
  "custom_csm": "bobbi@repli360.com",
  "custom_qb_id": "4724",
  "custom_pixel_id": "1035508496598043",
  "custom_repli_id": "9147445529",
  "custom_text_us_url": "https://popcard.rentcafe.com/TextUsWidget.aspx?dnis=7012040018",
  "custom_google_gtm_id": "GTM-55Z9L9TP",
  "custom_rollout_phase": "Phase 8",
  "custom_vibesites_theme": "Comfy",
  "custom_ads_subscription": "none",
  "custom_rentcafe_chatbot": "<script type=\"text/javascript\" src=\"//webchat.omni.cafe/conversations/dfa8c2c4-987a-4f92-ae88-be4591c9d849/app.js?property=dfa8c2c4-987a-4f92-ae88-be4591c9d849&propertyName=Dakota+Commons+Apartment+Homes&channelUuid=c248ebd9-8dac-11ec-afb4-42010aa42b&buttonbgcolor=012345\" defer></script>",
  "custom_seo_subscription": "none",
  "custom_hubspot_company_id": "47745296913",
  "custom_social_subscription": "none",
  "custom_website_subscription": "turnkey",
  "custom_apartmentsync_javascript_id": "eyJpdiI6Ii91ZjlsY05seTRYclhwVHZsNTAvanc9PSIsInZhbHVlIjoic3hWWWNFVEp6ZFA5ZWZjWHB0cnVHdz09IiwibWFjIjoiZmM3N2VjNjc5MzhlYTk3YTlmMmRjNjA2ZWMzZTlkMTQyMWMxMTc3MWE2YjE5NzBkZDJjOTU5MjM4M2Y2YzVmYyJ9",
  "custom_audioeye_site_id": "fa02e293-ba2a-4107-8127-ad999da50793",
  "custom_audioeye_site_hash": "2412d20fcd8c76e78c6f77dfdd7758a3"
};

export const generatedAt = '2026-11-04T21:28:05.322Z';
